import React from "react";
import { TitleText } from "../../../ui/Text";
import { RadioInput } from "../../../ui/RadioInput";
import { get } from "../../../utils/get";
import { SCORECARD_URL } from "../../../api/urls";
import { GetHook } from "../../../api/api";
import { ReviewPerspective } from "./ReviewPerspective";

interface IProps {
  user: { label: string; value: string };
}

export const ReviewQuestions = ({ user }: IProps) => {
  const { data: ownerScorecards } = GetHook(
    `${SCORECARD_URL}?owner_id=${user.value}`
  );
  return (
    <div>
      <TitleText style={{ marginBottom: "2em", marginTop: "-2em" }}>
        {user.label}
      </TitleText>
      {ownerScorecards.map((scorecard) => (
        <ReviewPerspective scorecardId={get(scorecard, "id")} />
      ))}
    </div>
  );
};
